import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

const CarDetailsButton = ({ car, index, onDetails }) => {
    const { t } = useTranslation('vinExtraction');

    return (
        <Button
            type="link"
            size="small"
            aria-label={t('cars.detailsAria', { id: car.carId })}
            onClick={event => onDetails(car, index, event.currentTarget)}
        >
            {t('cars.details')}
        </Button>
    );
};

export default CarDetailsButton;
